const commentsTemplate = (functionInst) => {
  if (Object.keys(functionInst).length === 0) return '/** please generate front sdk */';
  const { returnType } = functionInst;
  let jsType = returnType?.jsType || '';
  if (jsType === '' && !returnType.primitive) jsType = 'Object';
  return `/** This is a comment template
  * @param {string} paramName
  * @return {${jsType}} ${returnType.modelName}
  */`;
};

const initializeScript = ({ annotation, component, functionInst }) => {
  if (!annotation?.annotationType) {
    return (
      component.attributes.script ||
      `document.getElementById('${component.attributes.attributes.id}').onclick = (event) => {};`
    );
  }
  if (
    (annotation && annotation.annotationType === 'method') ||
    annotation.annotationType === 'algorithmic resource'
  )
    return (
      annotation?.customCode ||
      `${commentsTemplate(functionInst)}
      function pre${annotation.method}(param) { // insert code here
      }`
    );
  return 'something went wrong';
};

function getProjects() {
  return JSON.parse(localStorage.getItem('data'));
}

function getCurrentProject() {
  return getProjects()[JSON.parse(localStorage.getItem('selectedProject'))];
}

const paramsScript = (editor) => {
  const component = editor.getSelected();
  const annotationName = component.attributes.attributes.annotationname;

  const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
  const project = getCurrentProject();
  const annotation = project.annotations[0].combinations.find(
    (combi) => combi.annotationName === annotationName
  );
  const functionInst =
    project.pages[selectedPage]?.javascript?.functions.find(
      (functionInstTemp) => functionInstTemp.functionName === annotation?.method
    ) || {};
  //  console.log(functionInst);
  return { functionInst, component };
};

const wrapperScript = (editor) => {
  const component = editor.getSelected();
  const annotationName = component.attributes.attributes.annotationname;

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  const project = JSON.parse(localStorage.getItem('data'))[selectedProject];
  const annotation = project.annotations[0].combinations.find(
    (combi) => combi.annotationName === annotationName
  );

  return { annotation, component };
};

const handleInsertCodePanel = (editor) => {
  const modal = editor.Modal;
  const codeViewer = editor.CodeManager.getViewer('CodeMirror').clone();
  const container = document.createElement('div');
  const btnEdit = document.createElement('button');
  const btnEditToAnnotation = document.createElement('button');

  codeViewer.set({
    codeName: 'javascript',
    readOnly: 0,
    theme: 'hopscotch',
    autoBeautify: true,
    autoCloseTags: true,
    autoCloseBrackets: true,
    lineWrapping: true,
    styleActiveLine: true,
    smartIndent: true,
    indentWithTabs: true,
    annotationName: ''
  });

  btnEdit.innerHTML = 'Insert';
  btnEdit.className = 'gjs-btn-prim , buttonExportStyle, buttonExportStyle3';
  btnEdit.onclick = () => {
    const code = codeViewer.editor.getValue();
    editor.getSelected().set('script', code.trim());
    modal.close();
  };

  function handleClickSaveToAnnotation() {
    const { annotationName } = codeViewer.attributes;
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const projects = JSON.parse(localStorage.getItem('data'));
    const { combinations } = projects[selectedProject].annotations[0];
    combinations[
      combinations.findIndex((combi) => combi.annotationName === annotationName)
    ].customCode = codeViewer.editor.getValue();
    projects[selectedProject].annotations[0].combinations = combinations;
    localStorage.setItem('data', JSON.stringify(projects));
    modal.close();
  }

  btnEditToAnnotation.innerHTML = 'Insert to server';
  btnEditToAnnotation.className = 'gjs-btn-prim , buttonExportStyle, buttonExportStyle3';
  btnEditToAnnotation.onclick = handleClickSaveToAnnotation;

  editor.Commands.add('handleInsertCodePanel', {
    run() {
      let viewer = codeViewer.editor;
      const component = editor.getSelected();
      const annotationName = component.attributes.attributes.annotationname;
      const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
      const project = JSON.parse(localStorage.getItem('data'))[selectedProject];
      const annotation = project.annotations[0].combinations.find(
        (combi) => combi.annotationName === annotationName
      );
      let button = btnEdit;

      if (annotation && annotation.annotationType === 'method') {
        codeViewer.attributes.annotationName = annotation.annotationName;
        btnEditToAnnotation.onclick.bind(selectedProject, annotationName);
        button = btnEditToAnnotation;
      }
      // Here it intialize the editor.
      const { functionInst } = paramsScript(editor);
      const compScript = initializeScript({ ...wrapperScript(editor), functionInst });
      if (!viewer) {
        const txtarea = document.createElement('textarea');
        container.appendChild(txtarea);
        container.appendChild(button);

        codeViewer.init(txtarea);
        viewer = codeViewer.editor;
      }

      codeViewer.setContent(compScript);

      modal
        .open({
          title: 'Insert code',
          content: container
        })
        .getModel()
        .once('change:open', () => {
          editor.stopCommand(this.id);
          document.getElementById('editDataElementPopUp').style.visibility = 'inherit';
        });
      viewer.refresh();
    },
    stop() {
      document.getElementById('editDataElementPopUp').style.visibility = 'inherit';
    }
  });
};

export default handleInsertCodePanel;
